import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { CommonService } from 'src/app/services/common.service';
import { Product } from 'src/app/models/virtual-store/product.model';
import { Router, ActivatedRoute } from '@angular/router';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { MonthlyPaymentMode } from 'src/app/models/virtual-store/monthly-payment.model';
import { forkJoin, Subscription } from 'rxjs';
import { Account } from 'src/app/models/account.model';
import { OrderItemService } from 'src/app/services/order-item.service';
import { MatDialog } from '@angular/material';
import { LoginComponent } from '../../login/login.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { OrderItemInsertRequest } from 'src/app/models/virtual-store/order-item-insert-request.model';
import { SAPClientType } from 'src/app/enums/sap-client-type.enum';
import { Service } from 'src/app/models/virtual-store/service.model';
import { Deferred } from '../../../../../node_modules/ts-deferred';
import { PopupServiceComponent } from '../../modals/popup-service/popup-service.component';
import { PopupCartComponent } from '../../modals/popup-cart/popup-cart.component';
import { AppConstant } from 'src/app/constants/app.constant';
declare var fbq: Function;
@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {
  isClient: boolean;
  event: MouseEvent;
  clientX = 0;
  clientY = 0;
  clientScale = 1;
  isbuttonActive:string = 'tambienCompraron'
  collapseMobileProducto:any[] = [
    { title: 'También compraron esto', value:'tambienCompraron'},
    { title: 'También vieron esto', value:'tambienVieron'},
    { title: 'Productos relacionados', value:'productosRelacionados'},
    { title: 'Te puede interesar', value:'tePuedeInteresar'},
  ]
  showData:boolean = false

  singleProductConfig = { slidesToShow: 1, slidesToScroll: 1, dots: true };
  upsellsConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  upsellsServicesConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  showAddButton: boolean = true;
  mostBoughtProductList: Product[] = [];
  mostSeenProductList: Product[] = [];
  relatedProductList: Product[] = [];
  interestingProductList: Product[] = [];
  servicesProductList: Service[] = [];
  bottomList: Product[] = [];
  selectedMonthlyPaymentMode = new MonthlyPaymentMode();
  product = new Product();

  productCount: number = 1;
  account: Account;
  /*Suscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;
  //promise: Promise<void>;
  accountDataFetchedSubscription: Subscription;
  isProductFnb: boolean;
  codeFilterFnb:string=AppConstant.FNB; 

  constructor(private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private virtualStoreService: VirtualStoreService,
    private orderItemService: OrderItemService,
    private matDialog: MatDialog,
    private authService: AuthService) {
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.account = account;            
    });
    this.accountDataFetchedSubscription = this.commonService.accountDataFetchedAnnounced.subscribe(accountData => {
      this.showAddButton = accountData.clientTypeCode == SAPClientType.Residencial;
    });
  }

  ngOnInit() {
    window.scrollTo(0, 500);

    if (!this.authService.IsStandaloneModule()) {
      this.isClient = true;
    }
    // if (this.authService.getAuthToken() && !this.authService.checkIfItIsInsideIframe()) {
    //   this.isClient = true;
    //   this.showAddButton = true;
    // }

    this.product = this.virtualStoreService.receiveProductFromCatalogPacket();    
    if (this.product == null || this.product === undefined) {
      this.activatedRoute.queryParams
        .subscribe(params => {
          if (params.prdct) {
            this.virtualStoreService.getProduct(params.prdct).subscribe(response => {
              if (response.valid) {
                this.product = response.data;
                this.isProductFnb=(this.product.categoriaFnbId > 0);
                this.selectedMonthlyPaymentMode = this.product.monthlyPaymentModeList[0];
                if(!this.isProductFnb){
                  this.listBottomProducts();
                }
              }
            })
          } else this.router.navigate(['../'], { relativeTo: this.activatedRoute });
        });
    } else {
      this.isProductFnb=(this.product.categoriaFnbId > 0);
      this.selectedMonthlyPaymentMode = this.product.monthlyPaymentModeList[0];
      if(!this.isProductFnb){
        this.listBottomProducts();
      }
    }  
  }

  onEventLeave(event: MouseEvent): void {
    this.clientX = 0;
    this.clientY = 0;
    this.clientScale = 1;
  }

  coordinates(event: MouseEvent): void {
    this.clientX = event.clientX;
    this.clientY = event.clientY;
    this.clientScale = 2.76;
  }
  ngOnDestroy() {
    this.accountSelectedSubscription.unsubscribe();
  }
  listBottomProducts() {    
    forkJoin(
      this.virtualStoreService.listMostBoughtProducts(),
      this.virtualStoreService.listMostSeenProducts(this.isProductFnb),
      this.virtualStoreService.listRelatedProducts(this.product.subCategoryId,this.isProductFnb),
      this.virtualStoreService.listInterestingProducts(this.product.id,this.isProductFnb),
      this.virtualStoreService.listRelatedServices(this.product.id)
    ).subscribe(responses => {
      if (responses[0].valid) { this.mostBoughtProductList = responses[0].data; }
      if (responses[1].valid) { this.mostSeenProductList = responses[1].data; }
      if (responses[2].valid) { this.relatedProductList = responses[2].data; }
      if (responses[3].valid) { this.interestingProductList = responses[3].data; }
      if (responses[4].valid) { this.servicesProductList = responses[4].data; }

     

      if(!this.isProductFnb){
        this.bottomList = this.mostBoughtProductList;
      }else {
      this.bottomList = this.mostSeenProductList;
      this.isbuttonActive= 'tambienVieron';
      }
    });
  }
  listMostBoughtProducts() {
    this.virtualStoreService.listMostBoughtProducts().subscribe(response => {
      this.mostBoughtProductList = response.data;
    });
  }
  listMostSeenProducts() {
    this.virtualStoreService.listMostSeenProducts(this.isProductFnb).subscribe(response => {
      this.mostSeenProductList = response.data;
    });
  }
  listRelatedProducts() {
    this.virtualStoreService.listRelatedProducts(this.product.subCategoryId,this.isProductFnb).subscribe(response => {
      this.relatedProductList = response.data;
    });
  }
  listInterestingProducts() {
    this.virtualStoreService.listInterestingProducts(this.product.id, this.isProductFnb).subscribe(response => {
      this.interestingProductList = response.data;
    });
  }
  addToShoppingCart($event: any) {
    if (this.isClient) {
      const orderItem = new OrderItemInsertRequest();
      orderItem.productId = this.product.id;
      orderItem.count = this.productCount;
      orderItem.clientCode = this.account.clientCode;
      orderItem.monthlyPaymentCount = this.selectedMonthlyPaymentMode.monthCount; 
      orderItem.documentType=this.authService.getBasicData().documentType;
      orderItem.documentNumber=this.authService.getBasicData().documentNumber;    
      this.orderItemService.addPendingOne(orderItem).subscribe(response => {
        if (response.valid) {
          this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
          this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);          

          const servicesAggregate = this.servicesProductList.filter(x => x.aggregate);

          if(servicesAggregate.length > 0)
          {
            this.registerServices(servicesAggregate)
            .then(([]) => {​​​​​​​​            
              this.showModalAddCart(servicesAggregate);
            });
          }
          else
          {
            this.showModalAddCart([]);
          }          
        } else if (!response.valid && response.warning) {
          Swal.fire('Información', response.message, 'warning')
          this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
          this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
        }
      })

    } else {
      this.openLoginModal($event);
    }
    fbq('track', 'AddToCart');
  }

  showModalAddCart(services: Service[])
  {
    this.orderItemService.listPendingOnes(this.account.clientCode,this.isProductFnb).subscribe(
      response => {
        if (response.valid) 
        {            
          console.dir(response.data);
          if(response.data.length > 0){
            this.matDialog.open(PopupCartComponent, {
              width: '750px',
              disableClose: true,
              data: {
                orderItemList: response.data,
                clientCode:this.account.clientCode
              }
            });
          }    
        }
      }
    )

    /*const html = this.obtenerHtmlModal(services);

    Swal.fire({
      //title: '¡Añadido al carrito!',
      //text: 'El artículo se añadió correctamente a tu carrito',
      html: html,
      showCancelButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      cancelButtonText: 'AÑADIR MÁS',
      confirmButtonColor: '#1e9fda',
      //cancelButtonColor: '#1e9fda',
      cancelButtonColor: '#25a725',
      confirmButtonText: 'CONTINUAR',
      width: 1000
    })
      .then((result) => {
        if (result.value) {
          this.router.navigate(['ofivirtual/tienda/mi-carrito']);
        } else if (result.dismiss.toString() === 'cancel') {
          this.router.navigate(['ofivirtual/tienda']);
        }
      });*/
  }

  public registerServices(
    listServices: any[]
  ): Promise<any> {
    const dfd: Deferred<any> = new Deferred<any>();
    let i: number = 1;
    let results: any[] = [];

    for (const element of listServices) {

      const orderItemServices = new OrderItemInsertRequest();
      orderItemServices.productId = element.serviceId;
      orderItemServices.count = 1;
      orderItemServices.clientCode = this.account.clientCode;
      orderItemServices.monthlyPaymentCount = element.monthlyPaymentCount;

      this.orderItemService.addPendingOne(orderItemServices).subscribe(response => {
        if (response.valid) {
          this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
          this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
        }

        results.push(response);

        if (i === listServices.length) {
          dfd.resolve(results);
        }

        i += 1;

      });

    }
    return dfd.promise;
  }

  openLoginModal($event: any) {
    this.matDialog.open(LoginComponent, {
      data: {
        productId: this.product.id,
        productCount: this.productCount,
        monthlyPaymentMode: this.selectedMonthlyPaymentMode,
        clientY: $event.clientY
      },
      position: {
        top: ($event.clientY - 250)+'px'
      }
    });
  }
  updateBottomList(reference: string) {
    
    this.isbuttonActive = reference

    switch (reference) {
      case 'tambienCompraron':
        this.bottomList = this.mostBoughtProductList;
        this.showData = (this.bottomList) ? true : false
        break;
      case 'tambienVieron':
        this.bottomList = this.mostSeenProductList;
        this.showData = (this.bottomList) ? true : false
        break;
      case 'productosRelacionados':
        this.bottomList = this.relatedProductList;
        this.showData = (this.bottomList) ? true : false
        break;
      case 'tePuedeInteresar':
        this.bottomList = this.interestingProductList;
        this.showData = (this.bottomList) ? true : false
        break;
    }

  }
  getMainImage(product: Product) {
    if (product.imageList && product.imageList.filter(x => x.isMain).length > 0) {
      return product.imageList.find(x => x.isMain).source;
    } else { return null; }
  }
  getMonthlyMinimumAmount(product: Product) {
    return Math.min(...product.monthlyPaymentModeList.map(mode => mode.amountPerMonth));
  }
  changeProduct(product: Product) {
    this.product = product;
    this.selectedMonthlyPaymentMode = this.product.monthlyPaymentModeList[0];
    if(!this.isProductFnb){
      this.listBottomProducts();
    }
  }
  breakpoint(e) {
    // console.log('breakpoint');
  }

  cleanBottomList() {
    this.showData = false; 
    this.bottomList = []
  }

  addService(item: Service)
  {
    this.virtualStoreService.getProduct(item.serviceId).subscribe(response => {
      if (response.valid) {
        const dialog = this.matDialog.open(PopupServiceComponent, {
          width: '750px',
          disableClose: true,
          data: {
            service: response.data,
            itemService: item
          }
        });
        dialog.afterClosed().subscribe(responseModal => {
          item = responseModal;
        })
      }
    })
  }

  removeService(item: Service)
  {
    item.aggregate = false;
  }

  obtenerHtmlModal(services: Service[])
  {
    let urlImageProduct = this.getMainImage(this.product);
    urlImageProduct = urlImageProduct === null ? "assets/images/virtual-store/default_image.png": urlImageProduct;
    let tiendaVirtual = this.product.price - this.product.ofvDiscount;

    let html = "";
    html +=  "<div class='title-services-carrito'>Producto(s) agregado(s) al carrito de compras</div>";
    html +=  "<div class='upsells-content-services border-product'>";
    html +=  "  <div class='row'>";
    html +=  "    <div class='col-md-3'>";
    html +=  "      <img src='[urlImagen]'>";
    html +=  "    </div>";
    html +=  "    <div class='col-md-4'>";
    html +=  "      <div class='content-services-description' style='font-size: 14px;'>" + this.product.description + "</div>";
    html +=  "      <div class='content-services-precio-descuento' style='font-size: 13px !important;'>Precio: S/ " + this.product.price.toFixed(2) + "</div>";
    html +=  "      <div class='content-services-precio-real yellowText' style='font-size: 13px;'>Oferta: S/ " + tiendaVirtual.toFixed(2) + "</div>";                                  
    html +=  "    </div>";
    html +=  "    <div class='col-md-2'>";
    html +=  "      <div class='content-services-description' style='font-size: 11px;'>Cuotas : " + this.productCount + "</div>";
    html +=  "      <div class='content-services-description yellowText' style='font-size: 12px;'>S/ " + tiendaVirtual.toFixed(2) + "</div>";
    html +=  "    </div>";
    html +=  "    <div class='col-md-3'>";
    html +=  "      <div class='content-services-description2'><span> - 1 + </span></div>";
    html +=  "    </div>";
    html +=  "  </div>";
    html +=  "</div>";
    html +=  "<div class='title-services-carrito' style='padding-top: 10px; padding-bottom: 15px;'>Contrata servicios complementarios</div>";
    
    html = html.replace('[urlImagen]', urlImageProduct);

    services.forEach(element => {

      let precioDescuento = element.regularPrice - element.discountOfv;
      
      html +=  "<div class='upsells-content-popup active-services' style='margin-bottom: 5px;'>";
      html +=  "  <div class='row'>";
      html +=  "    <div class='col-md-4'>";
      html +=  "      <img src='assets/images/virtual-store/default_image.png'>";
      html +=  "    </div>";
      html +=  "    <div class='col-md-6'>";
      html +=  "      <div class='content-services-description'>" + element.name + "</div>";
      html +=  "      <div class='content-services-precio-descuento'>S/ " + precioDescuento.toFixed(2) + "</div>";
      html +=  "      <div class='content-services-precio-real tachado'>S/ " + element.regularPrice.toFixed(2) + "</div>";
      html +=  "    </div>";
      html +=  "    <div class='col-md-2' style='padding-left: 0px;'>";
      html +=  "      <button mat-flat-button class='icon-services' style='min-width: 60px;' (click)='addService(item)' [disableRipple]='true'>";
      html +=  "        <img style='width: 23px; height: 23px;' src='assets/images/virtual-store/shopping-cart.png'>";
      html +=  "      </button>";
      html +=  "      <button mat-flat-button class='icon-services' style='min-width: 60px;' [disableRipple]='true'>";
      html +=  "        <img style='width: 23px; height: 23px;' src='assets/images/virtual-store/shopping-detalle-cart.png'>";
      html +=  "      </button>";
      html +=  "    </div>";
      html +=  "  </div>";
      html +=  "</div>";
    });    

    return html;
  }
}
